export function TeamSlider() {
    const $holder = $(".team-slider-holder");
    const $slider = $holder.find(".team-slider");
    const $prev = $holder.find(".prev");
    const $next = $holder.find(".next");
    const $sliderNav = $holder.find(".slider-nav");
    const $currSlide = $holder.find(".current");
    const $countSlides = $holder.find(".count");
    $slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        if (slick.$dots) {
            let $dotsItems = slick.$dots.find("li");
            let activeDot = $dotsItems.filter(".slick-active");
            $sliderNav.removeAttr('style')
            $currSlide.text($dotsItems.index(activeDot) + 1);
            $countSlides.text(slick.$dots.find("li").length);
        } else {
            $sliderNav.css('display', 'none')
        }

    });

    $slider.slick({
        dots: true,
        arrows: true,
        infinite: false,
        draggable: true,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: $prev,
        nextArrow: $next,

        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },

            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3

                }
            }
        ]
    });

}



// WEBPACK FOOTER //
// ./assets/js/modules/TeamSlider.js